import {
  CompiledQuery,
  KyselyPlugin,
  PluginTransformQueryArgs,
  PluginTransformResultArgs,
  QueryResult,
  RootOperationNode,
  UnknownRow,
} from 'kysely';

export interface ResultReuseOptions {
  resultReuse?: boolean;
  resultReuseMaxAgeMinutes?: number;
  resultReuseHash?: string;
}

export type ResultReusableRootOperationNode = RootOperationNode & {
  resultReuseOptions: ResultReuseOptions;
};

export type ResultReusableCompiledQuery = CompiledQuery & {
  resultReuseOptions: ResultReuseOptions;
};

export function isResultReusableNode(
  node: RootOperationNode,
): node is ResultReusableRootOperationNode {
  return !!(node as any).resultReuseOptions;
}

export function isResultReusableQuery(
  query: CompiledQuery,
): query is ResultReusableCompiledQuery {
  return !!(query as any).resultReuseOptions;
}

export class ResultReusePlugin implements KyselyPlugin {
  constructor(private readonly options?: ResultReuseOptions) {}

  transformQuery(args: PluginTransformQueryArgs): RootOperationNode {
    if (this.options) {
      return {
        ...args.node,
        resultReuseOptions: this.options,
      } as ResultReusableRootOperationNode;
    } else {
      return args.node;
    }
  }

  async transformResult(
    args: PluginTransformResultArgs,
  ): Promise<QueryResult<UnknownRow>> {
    return args.result;
  }
}
